import { PropsWithChildren } from 'react';

interface IProps {
    stateName?: string | undefined;
    heroimagemobile?: string;
    heroimagetablet?: string;
    heroimagedesktop?: string;
    children?: any;
}

const PerformancePartners = ({
    stateName = 'your state',
    heroimagemobile = '',
    heroimagetablet = '',
    heroimagedesktop = '',
    children = null,
}: PropsWithChildren<IProps>) => {
    function prefixImageLink(imageLink: string): string {
        if (
            'production' === process.env.NODE_ENV &&
            imageLink &&
            !imageLink.includes(process.env.GATSBY_PATH_PREFIX) &&
            !imageLink.includes('data:image/')
        ) {
            return `${process.env.GATSBY_PATH_PREFIX}${imageLink}`;
        }
        return imageLink;
    }

    const modMobileImage = prefixImageLink(heroimagemobile);
    const modTabletImage = prefixImageLink(heroimagetablet);
    const modDesktopImage = prefixImageLink(heroimagedesktop);

    return (
        <div className="flex justify-center bg-surface-100 mb-8 lg:mb-16 px-4 md:px-0 lg:px-0">
            <div className="flex flex-col justify-center align-middle w-full max-w-screen-2xl">
                <div className="w-full max-w-screen-xl self-center">
                    <div className="pt-6 lg:pt-12 md:px-24 lg:px-0">{children}</div>

                    <div className="flex flex-wrap content-center lg:min-h-[400px] md:pl-6 lg:pl-0 mt-6 lg:mt-12">
                        <div className="w-full md:w-3/5 lg:w-3/5 h-auto mb-12 lg:pl-6 lg:pr-52 z-50">
                            <div className="px-6 py-8 md:p-6 lg:p-8 lg:my-8 bg-white">
                                <p className="pre-ul-p md:text-18 text-center md:text-start md:pr-12 lg:pr-0">
                                    Please have the following information on-hand when contacting
                                    eHealth:
                                </p>

                                <ul className="list-disc pt-4 lg:pt-6 text-start">
                                    <li>Names of your doctors</li>
                                    <li>Current prescription drug names and dosages</li>
                                    <li>Your Medicare ID card</li>
                                    <li>Your Medicaid information, if applicable</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="self-end hidden md:flex md:-mt-[300px] lg:-mt-[400px]">
                    {/* ---- Tablet ---- */}
                    <span className="justify-end hidden md:flex lg:hidden">
                        <img
                            src={modTabletImage}
                            width={650}
                            height={'auto'}
                            alt=""
                            className="z-0"
                        />
                    </span>
                    {/* ---- Desktop ---- */}
                    <span className="justify-end hidden lg:flex">
                        <img
                            src={modDesktopImage}
                            width={'auto'}
                            height={400}
                            alt=""
                            className="z-0"
                        />
                    </span>
                </div>
            </div>
        </div>
    );
};

export default PerformancePartners;
